import {
  Datagrid,
  TextField,
  List,
  EditButton,
} from "react-admin";

const ScriptOverrideList = () => {
  return (
    <List
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Datagrid>
        <TextField source="script.name" />
        <TextField source="name" />
        <TextField source="minLvl" />
        <TextField source="maxLvl" />
        <EditButton />
      </Datagrid>
    </List>
  );
};

export default ScriptOverrideList;
